import React from "react";
import { Button, BUTTON_STYLE_LINK } from "@ca-dmv/core";
import { ButtonBack } from "@ca-dmv-radv/components";
import { useTranslation } from "@ca-dmv-radv/translation";
import "./GetStarted.css";

const GetStarted = () => {
  const { t } = useTranslation();
  const handleStartVerification = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const isPvDependency = searchParams.get('isPvDependency') === 'true';

    if (isPvDependency) {
      window.location.href = "document-upload";
    } else {
      window.location.href = "presence-verification";
    }
  };

  return (
    <div className="verification-screen">
      <div className="verification-header">
        <h1>Get Started</h1>
        <p>ADD helpful test here. and more and more and mores  </p>
      </div>

      <div className="step-card">
        <span className="step-number">01</span>
        <div className="step-icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z" fill="white" />
            <path d="M12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="white" />
          </svg>
        </div>
        <div className="step-content">
          <h2>Take a selfie</h2>
          <p>Ensure your face is well-lit and clearly visible in the frame.</p>
        </div>
      </div>

      <div className="step-card">
        <span className="step-number">02</span>
        <div className="step-icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18ZM7 15H17V17H7V15ZM7 11H10V14H7V11ZM11 11H13V12H11V11ZM11 13H13V14H11V13ZM14 11H17V12H14V11ZM14 13H17V14H14V13Z" fill="white" />
          </svg>
        </div>
        <div className="step-content">
          <h2>Capture license</h2>
          <p>Take a high-quality photo of the front and back of your driving license.</p>
        </div>
      </div>

      <div className="step-card">
        <span className="step-number">03</span>
        <div className="step-icon-wrapper">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18ZM7 15H17V17H7V15ZM7 11H10V14H7V11ZM11 11H13V12H11V11ZM11 13H13V14H11V13ZM14 11H17V12H14V11ZM14 13H17V14H14V13Z" fill="white" />
          </svg>
        </div>
        <div className="step-content">
          <h2>Review Selfie</h2>
          <p>Review your selfie and submit it to continue.</p>
        </div>
      </div>

      <Button
        label="Start Verification"
        onClick={handleStartVerification}
        buttonClass="start-btn"
      />

      <Button
        label="I'll do this later"
        btnStyle={BUTTON_STYLE_LINK}
        buttonClass="later-link"
        onClick={() => {
          window.location.href = "/";
        }}
      />
    </div>
  );
};

export default GetStarted;
